import { graphql } from "gatsby";
import React, { type FC, type HTMLAttributes } from "react";
import { useInPageNavId } from "../../context/InPageNav/useInPageNavId";

import type { GatsbyImageProps } from "gatsby-plugin-image";
import { Sponsor, SponsorsList } from "../Sponsors/Sponsors";

interface Props extends HTMLAttributes<HTMLElement> {
	node?: Queries.SponsorsParagraphDataFragment;
}

export const SponsorsParagraph: FC<Props> = ({ node, ...props }) => {
	const id = useInPageNavId(node);

	if (!node) return null;

	const listTitle = node.field_title;

	const items = node.relationships?.items?.map((item) =>
		item
			? {
					id: item.id,
					name: item.name,
					body: item.body,
					url: item.url,
					rawImage: {
						src: item.relationships?.field_media?.relationships
							?.field_media_image?.uri?.url,
					},
					image: item.relationships?.field_media?.relationships
						?.field_media_image?.childImageKitAsset?.fluid as GatsbyImageProps,
				}
			: null,
	);

	if (!items?.length) return null;
	return (
		<SponsorsList heading={listTitle} id={id} {...props}>
			{items.map((item) => {
				if (!item) return null;

				const { id, ...rest } = item;
				return <Sponsor key={id} {...rest} />;
			})}
		</SponsorsList>
	);
};

// Exporting a fragment allows it to be used in any GraphQL query

export const fragment = graphql`
    fragment SponsorsParagraphData on paragraph__sponsors {
        id
        field_title
        field_is_on_this_page_anchor
        relationships {
            items: field_content_paragr {
                id
                name: field_sponsor_name
                body: field_spon
                url: field_sponsor_url {
                    linkText: title
                    link: uri
                }
                relationships {
                    field_media {
                        relationships {
                            field_media_image {
                                childImageKitAsset {
                                    fluid(maxWidth: 267) {
                                        ...ImageKitFluid
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export default SponsorsParagraph;
